// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__37o6w","upload":"Small_upload__1NYVx","imageWrap":"Small_imageWrap__1cdE6","removeBtn":"Small_removeBtn__2eZbe"};